import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Misc_Bill_Modal from "../components/miscBillPassingGRNModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddMiscBillPassing = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [priNumber, setPriNumber] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [header, setHeader] = useState({})
const [formData, setFormData] = useState({})
const [billDetail, setBillDetail] = useState({})
const [poNumbers, setPoNumbers] = useState([]);
const navigate = useNavigate();

const canEntry = hasPermission("Bill Passing Menu - Branch", "entry");

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchase_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, []);

const handleSelectItem = async (supplier) => {
    try {
      setPriNumber(supplier.grnheader_number);
      setSupplierNo(supplier.grnheader_suppliercode);
  
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/miscBillPassing_getSupplierItems", {
        params: {
          grnNo: supplier.grnheader_number,
          branch: branch,
        },
      });
  
      if (response.data.length > 0) {
        setSelectedItems(response.data);
  
        // Extract unique PO Numbers
        const poNumbers = [...new Set(response.data.map(item => item.grnDetail_poNumber))];
  
        // Log PO Numbers to the console
        console.log("Extracted PO Numbers:", poNumbers);
  
        setPoNumbers(poNumbers); // Assuming you have a state for this
      }
    } catch (error) {
      console.error("Error fetching supplier items:", error);
    }
  };

  useEffect(() => {
    const fetchHeaderFright = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscGrnBill_fetchFrights?poNo=${poNumbers}&branch=${branch}`);
            const items = response.data.fetchFright;
            
            const storeReqHeader = {
                freight: items[0].purchaseOrderHeader_freightCharges  || 0,
                paymentTerms: items[0].purchaseOrderHeader_paymentTerms,
                delMethod : items[0].purchaseOrderHeader_deliveryMethod,
                remarks : items[0].purchaseOrderHeader_remarks,
              
                
            };
            setBillDetail(storeReqHeader);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchHeaderFright();
  }, [poNumbers, branch]); 


    

// useEffect(() => {
//   const fetchFreightCharges = async () => {
//     if (!poNumbers) return; 

//     try {
//       const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscGrnBill_fetchFrights?poNo=${poNumbers}&branch=${branch}`);
//       const items = response.data.fetchFright;

//       if (items.length > 0) {
//         setFreight(items[0].purchaseOrderHeader_freightCharges || "N/A"); 
//       }
//       console.log("frith:", response.data.fetchFright);
      
//     } catch (error) {
//       console.error("Error fetching freight charges:", error);
//     }
//   };

//   fetchFreightCharges();
// }, [poNumbers, branch]); 

useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeader1);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [supplierNo]); 


useEffect(() => {
    const fetchHeaderDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscBill_supDetails?grnNo=${priNumber}&branch=${branch}`);
            const items = response.data.headerDetails;
            const storeReqHeader2 = {
                grnheader_number: items[0].grnheader_number || "N/A",
                grnheader_DcNumber: items[0].grnheader_DcNumber || "N/A",
                grnheader_date : items[0].grnheader_date || "N/A",
                grnheader_invoiceNumber : items[0].grnheader_invoiceNumber || "N/A",
                grnheader_invoiceDate : items[0].grnheader_invoiceDate || "N/A",
                grnheader_DcDate : items[0].grnheader_DcDate || "N/A",
                
            };
            setHeader(storeReqHeader2);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchHeaderDetails();
  }, [priNumber, branch]); 


  // Calculate totals
  const totals = selectedItems.reduce(
    (acc, item) => {
        const itemValue = item.grnDetail_packedQuantity * item.grnDetail_price;
        const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
        const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
        const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
        const totalValue = itemValue + taxValue + pfValue - discountValue;

      acc.totalItemValue += itemValue;
      acc.totalDiscValue += discountValue;
      acc.totalTaxValue += taxValue;
      acc.totalPfValue += pfValue;
      acc.grandTotalValue += totalValue ;

      return acc;
    },
    {
      totalItemValue: 0,
      totalDiscValue: 0,
      totalTaxValue: 0,
      totalPfValue: 0,
      grandTotalValue: 0,
    }
  );

  const freightAmount = isNaN(parseFloat(billDetail.freight)) ? 0.00 : parseFloat(billDetail.freight);
  const finalTotal = totals.grandTotalValue + freightAmount;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

    const payload = {
        branch: branch,
        user: user,
        grnNo: header.grnheader_number,
        grnDate: header.grnheader_date,
        dcNo: header.grnheader_DcNumber,
        dcDate: header.grnheader_DcDate,
        invoiceNo: header.grnheader_invoiceNumber,
        invoiceDate: header.grnheader_invoiceDate,
        scode: subDetails.supplierMaster_code,
        paymentTerms: billDetail.paymentTerms,
        frightAmt: billDetail.freight,
        delMethod: billDetail.delMethod,
        grandTot : finalTotal,
        remarks: billDetail.remarks,
        accValue: totals.itemValue,
        subValue : totals.totalItemValue,
        pfValue: totals.totalPfValue,
        discValue: totals.totalDiscValue,
        gst: totals.totalTaxValue,
        poNo : poNumbers,
        items: selectedItems.map((item) => {
            const itemValue = item.grnDetail_packedQuantity * item.grnDetail_price;
                      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
                      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
                      const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

            return {
                itemCode: item.grnDetail_itemcode,
                itemName: item.grnDetail_itemName,
                itemUom: item.grnDetail_uom,
                qty: item.grnDetail_poPendingQuantity,
                price: item.grnDetail_price,
                accQty: item.grnDetail_packedQuantity,
                rejQty: item.grnDetail_excessShortageQuantity,
                cst: item.grnDetail_CSTtax,
                pf: item.grnDetail_pfPercentage,
                disc: item.grnDetail_discountPercentage,
                value: totalValue, 
                accValue: itemValue,
                // pfValue: pfValue.toFixed(2), 
                // discValue: discountValue.toFixed(2), 

            };
        }),
    };

    // console.log(payload);

    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/billBranch_insert", payload);
        Swal.fire("Success", "Misc Bill Passing  added successfully", "success");
        // alert("Success");
        setSelectedItems([]);
        navigate('/inventory/miscBillPassingGRNView');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                                        <h2 className="add-txt">Add Bill Passing GRN - Branch</h2>
                                        <Link to='/inventory/miscBillPassingGRNView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                        </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={header.grnheader_number} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="text" name="endhrs" value={new Date(header.grnheader_date).toLocaleDateString('en-GB')} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="yourRefNo" value={header.grnheader_DcNumber}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>D.C Date :</label>
                <input type="text" name="endhrs" value={new Date(header.grnheader_DcDate).toLocaleDateString('en-GB')} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="ourRefNo" value={header.grnheader_invoiceNumber}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="endhrs" value={new Date(header.grnheader_invoiceDate).toLocaleDateString('en-GB')} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>GRN Qty</th>
                    <th>Acc. Qty</th>
                    <th>Rej. Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                    <th>Bill Passing by</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.grnDetail_packedQuantity * item.grnDetail_price;
                      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
                      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
                      const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.grnDetail_itemcode}</td>
                          <td>{item.grnDetail_itemName}</td>
                          <td>{item.grnDetail_uom}</td>
                          <td>{item.grnDetail_poPendingQuantity}</td>
                          <td>{item.grnDetail_packedQuantity}</td>
                          <td>{item.grnDetail_excessShortageQuantity}</td>
                          <td>{item.grnDetail_price}</td>
                          <td>{item.grnDetail_CSTtax}</td>
                          <td>{item.grnDetail_pfPercentage}</td>
                          <td>{item.grnDetail_discountPercentage}</td>
                          <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totalValue)}</td>   
                            <td>{user}</td>
                        </tr>
                        
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Billing Summary */}
              <div className="po-bill-container">
                <h2 className="po-bill-title">Billing Summary</h2>
                <div className="po-bill-summary">
                  <div className="po-bill-item">
                    <span className="po-bill-label">Sub Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalItemValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">GST (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalTaxValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Disc (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalDiscValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">PF:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalPfValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Fright Charges:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(billDetail.freight)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Payment Terms:</span>
                    <span className="po-bill-value">{billDetail.paymentTerms}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Method:</span>
                    <span className="po-bill-value">{billDetail.delMethod}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Remarks:</span>
                    <span className="po-bill-value">{billDetail.remarks}</span>
                  </div>
                  <div className="po-bill-item po-bill-total">
                    <span className="po-bill-label">Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(finalTotal)}</span>
                  </div>

                </div>
              </div>


            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <Misc_Bill_Modal   showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddMiscBillPassing;
